import { Layout, Spin, Typography } from "antd"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { type ConnectedProps, connect } from "react-redux"
import { useParams } from "react-router"
import { useNavigate } from "react-router-dom"

import LoginHeader from "../components/LoginHeader"
import { generateDocumentTitle } from "../constants/document-title"
import { type RootState } from "../store"
import "./CheckEmailCode.less"
import { confirmEmail } from "./LoginPage/redux/auth.thunks"

const { Text } = Typography

const CheckEmailCode = ({
  confirmEmail,
  fetching
}: ConnectedProps<typeof connector>) => {
  const { hash } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    generateDocumentTitle("Confirm Email")
    if (hash)
      confirmEmail({
        hash,
        navigate
        // redirect: ""
      })
  }, [])

  return (
    <Layout>
      <div className="login-row">
        <LoginHeader withLogout={true} />

        <Spin spinning={fetching}>
          <div className="login-content check-email-code">
            <div className="page-content">
              <Text type="secondary">{t("Email confirmation")}</Text>
            </div>
          </div>
        </Spin>
      </div>
    </Layout>
  )
}

const mapStateToProps = (state: RootState) => ({
  fetching: state?.auth?.fetching
})

const mapDispatchToProps = {
  confirmEmail: confirmEmail
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(CheckEmailCode)
